import styled from 'styled-components';
import { spacing } from 'ui/theme/utils';

export const Separator = styled.div`
  width: ${({ width = '100%' }) => width};
  border-bottom: 1px solid ${({ color = '#ddd' }) => color};
  ${(props) => spacing(props)}
`;
